import BannerSect from '../components/Home/BannerSect';
import IntroduceSect from '../components/Home/IntroduceSect';
import PortfolioSect from '../components/Home/PortfolioSect';
import StorySect from '../components/Home/StorySect';

const Home = ({ AboutRef, PortfolioRef, ...props }) => {
  return (
    <>
      <BannerSect />
      <IntroduceSect AboutRef={AboutRef} />
      <PortfolioSect PortfolioRef={PortfolioRef} />
      <StorySect />
    </>
  )
}

export default Home;